import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";

export const initSentry = () => {
    Sentry.init({
        dsn: __myapp.env.SENTRY_DSN,
        integrations: [new Integrations.BrowserTracing()],
        tracesSampleRate: 1.0,
      });
};
